module.exports = __webpack_public_path__ + "static/img/news.4a466ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/news.png
// module id = Gvsr
// module chunks = 7